import React from 'react'

export default function TagComp({title, onClickFunc}) {
    const styles={
        // border: '1.2px solid #E0E2E6',
        borderRadius:'6px',
        height:'24px',
        padding:'1px 8px 1px 8px',
        color:'#fff',
        textAlign:'center',
        background:'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
        fontSize:'13px',
        marginLeft:'5px',
        fontWeight:'300',
        display:'flex',
        alignItems:'center',
        cursor:`${onClickFunc===undefined?"auto":'pointer'}`
    }
    const onClickTag=(tag)=>{
      if(onClickFunc===undefined){
      return;
      }
      onClickFunc(tag);
    }
  return (
    <div style={styles} onClick={()=>onClickTag(title)}>{title}</div>
  )
}
